'use strict';

function resizeWindow() {}

$(document).ready(function () {

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});
	resizeWindow();

	// SHOW T&C OF SPECIAL 12278
	// if ( document.getElementById('special12278') ) document.getElementById('special12278').querySelector('.reservations-full').style.display = 'block';

	//Acts when scroll down page.
	//    $(window).scroll(function (event) {
	//    	scrollDown();
	// 	var top = $(document).scrollTop(); 
	// 	if (top > 0) {

	// 	} else {

	// 	}
	// });
	$(".fancybox_inline").fancybox({
		'type': 'inline'
	});

	// Main Nav Dropdown
	$("#primary-nav li").hover(function () {

		$(this).addClass("hover");
		$('ul.submenu', this).fadeIn(200);
	}, function () {

		$(this).removeClass("hover");
		$('ul.submenu', this).fadeOut(200);
	});

	$('.open-booking-widget-inline-date').on('click', function (e) {
		$("#adults").val(2);
		$("#child").val(0);
		$("#number_guest").text("2 ADULTS");
	});

	$('.menu-trigger').click(function () {
		if ($(this).hasClass('open')) {
			$('#header .tablet-primary').fadeOut();
			var text = $(this).text();
			$('.menu-text').text('Menu');
			$('.menu-holder').removeClass('close');
		} else {
			$('#header .tablet-primary').fadeIn();
			$('.menu-text').text('Close');
			$('.menu-holder').addClass('close');
		}
	});
	$('.menu-trigger').click(function () {
		$(this).toggleClass('open');
	});

	//new specials page
	$('.read-more-specials').click(function (e) {
		$(this).next('div.special-full').slideToggle();
		var text = $(this).text();
		$(this).text(text == "Terms & Conditions -" ? "Terms & Conditions +" : "Terms & Conditions -");
	});
	$('.reservation-includes').click(function (e) {
		$(this).next('div.reservations-full').slideToggle();
	});

	//navigation on amenities shortcode when is slide
	$('.js-list-link').click(function () {
		$('.js-list-link').removeClass('active');
		$(this).addClass('active');
		var slideto = '#' + $(this).data("link");
		$('.container-slide').removeClass('show');
		$(slideto).addClass('show');
	});

	//SUBNAVIGATION

	// Open active sub-nav on load
	$('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
	$('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, 'easeOutQuart', function () {}).addClass('menu-open');

	//Toggle open/close on tap
	$('.navigation li a').off('click').on('click', function (event) {
		if ($(this).parent().children(".sub-sub-menu").length > 0) {

			event.preventDefault();

			if ($(this).next().hasClass('menu-open')) {
				$(this).parent().parent().removeClass('open');
				$(this).parent().removeClass('item-open');
				$(this).next().slideUp(300, 'easeOutQuart').removeClass('menu-open');
				console.log("close");
			} else {
				$(this).parent().parent().addClass('open');
				$(this).parent().addClass('item-open');
				$('.sub-sub-menu.menu-open').slideUp(300, 'easeOutQuart').removeClass('menu-open');
				$(this).next().slideDown(300, 'easeOutQuart', function () {}).addClass('menu-open');
				console.log("open");
			}
		}
	});
	// Navigation Available Max-Height
	var topSiblings = $('.navigation .inner').prevAll().outerHeight() + 20; // Add 20px padding-top
	var bottomSiblings = $('.navigation .inner').nextAll().height();
	var viewportHeight = $(window).height() * 0.95; // Substract 5% for top buttons

	var navigationHeight = viewportHeight - (bottomSiblings + topSiblings);
	$('.navigation .inner > ul').css("max-height", navigationHeight);
	// Remove the mobile redirect on tablet nav
	$(".tablet-primary .navigation .inner li a").each(function () {
		this.href = this.href.replace('/m/', '/');
	});

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight()
		}, 800, 'easeOutExpo');
	});

	// Home Page Map
	$('#home .map-home ul.pins li').click(function () {
		$('#home .map-home ul.pins li').removeClass('active');
		$(this).addClass('active');
		$('.each-location').fadeOut();
		$('#each-location' + $(this).attr('target')).fadeIn();
	});

	// if($('#home').length > 0) {
	// 	$('.white-bar-sp').addClass('open');
	// 	$('.sneak-peak').delay(6000).animate({right:'-562px'}, 500);
	// 	setTimeout(function(){
	// 		$('.white-bar-sp').removeClass('open');
	// 	}, 6000);
	// }


	$('.media-inquiry-btn').click(function () {
		$('#media-inquiry').fadeToggle();
	});
	$('.close-media-form').click(function () {
		$('#media-inquiry').fadeOut();
	});

	//Slick Slider
	$('.sym-slides').slick();

	$('.all-reasons').slick({
		arrows: true,
		dots: false,
		autoplay: false,
		autoplaySpeed: 4000,
		speed: 0,
		fade: true,
		accessibility: false,
		prevArrow: $('.prev-reason'),
		nextArrow: $('.next-reason')
	});

	$('.specials-slider').slick({
		arrows: true,
		dots: false,
		infinite: true,
		autoplay: false,
		autoplaySpeed: 3000,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		accessibility: true,
		// variableWidth: true,
		responsive: [{
			breakpoint: 769,
			settings: {
				slidesToShow: 2
			}
		}, {
			breakpoint: 600,
			settings: "unslick"
		}]
	});

	var $galHomeSlider = $('.gallery-home-slider').slick({
		arrows: true,
		dots: false,
		autoplay: false,
		autoplaySpeed: 4000,
		speed: 500,
		fade: true,
		accessibility: false,
		slidesToShow: 1,
		slidesToScroll: 1
	});
	$('.each-home-gal').click(function () {
		$galHomeSlider.slick('slickGoTo', parseInt($galHomeSlider.slick('slickCurrentSlide')) + 1);
	});

	$('.amenities-toggle').slick({
		fade: true,
		dots: true,
		appendDots: $('.amenities-nav'),
		customPaging: function customPaging(slider, i) {
			var title = $(slider.$slides[i]).data('title');
			return '<a>' + title + '</a>';
		}
	});

	if (document.getElementById('terms_btn')) {
		var btnTerms = document.getElementById('terms_btn');
		var termsInfo = document.getElementById('terms_info');
		var termsInfoHeight = termsInfo.getElementsByClassName('wrap')[0].clientHeight;
		btnTerms.addEventListener('click', function (e) {
			e.preventDefault();
			termsInfo.classList.toggle('open');
			if (!this.classList.contains('active')) {
				this.classList.add('active');
				termsInfo.style.height = termsInfoHeight + 'px';
			} else {
				this.classList.remove('active');
				termsInfo.style.height = '0px';
			}
		});
	}
	if (document.getElementsByClassName('terms-copy').length > 0) {
		var allTermsFancy = document.getElementsByClassName('js-terms');
		var allTermsLength = allTermsFancy.length;
		for (var j = 0; j < allTermsLength; j++) {
			allTermsFancy[j].addEventListener('click', function (e) {
				e.preventDefault();
				var target = this.getAttribute('href').split('#')[1];
				var wrapHeight = document.getElementById(target).getElementsByClassName('wrap')[0].clientHeight;
				if (!document.getElementById(target).classList.contains('open')) {
					this.classList.add('active');
					document.getElementById(target).classList.add('open');
					document.getElementById(target).style.height = wrapHeight + 'px';
				} else {
					this.classList.remove('active');
					document.getElementById(target).classList.remove('open');
					document.getElementById(target).style.height = '0px';
				}
			});
		}
	}

	var $status0 = $('.pagingInfo-0');
	var $slickElement0 = $('.sym-slides-counter-0');
	$slickElement0.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
		//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
		var i = (currentSlide ? currentSlide : 0) + 1;
		var ofCopy = '<span class="of-copy"> of </span>';
		$status0.html(i + ofCopy + slick.slideCount);
	});
	$slickElement0.slick({
		arrows: true,
		dots: false,
		autoplay: false,
		autoplaySpeed: 4000,
		speed: 500,
		fade: true,
		accessibility: false,
		prevArrow: $('.prev-gallery-0'),
		nextArrow: $('.next-gallery-0')
	});

	var $status1 = $('.pagingInfo-1');
	var $slickElement1 = $('.sym-slides-counter-1');
	$slickElement1.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
		//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
		var i = (currentSlide ? currentSlide : 0) + 1;
		var ofCopy = '<span class="of-copy"> of </span>';
		$status1.html(i + ofCopy + slick.slideCount);
	});
	$slickElement1.slick({
		arrows: true,
		dots: false,
		autoplay: false,
		autoplaySpeed: 4000,
		speed: 500,
		fade: true,
		accessibility: false,
		prevArrow: $('.prev-gallery-1'),
		nextArrow: $('.next-gallery-1')
	});

	var $status2 = $('.pagingInfo-2');
	var $slickElement2 = $('.sym-slides-counter-2');
	$slickElement2.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
		//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
		var i = (currentSlide ? currentSlide : 0) + 1;
		var ofCopy = '<span class="of-copy"> of </span>';
		$status2.html(i + ofCopy + slick.slideCount);
	});
	$slickElement2.slick({
		arrows: true,
		dots: false,
		autoplay: false,
		autoplaySpeed: 4000,
		speed: 500,
		fade: true,
		accessibility: false,
		prevArrow: $('.prev-gallery-2'),
		nextArrow: $('.next-gallery-2')
	});

	//Rotate the images slide when click on the custom arrows
	$('.slick-arrow').click(function () {
		var customData = $(this).attr('id').split('-'); // get arrow type and num slide by split id
		//conditional if is next or prev arrow
		if (customData[1] == 'prev') {
			$('.sym-slides-counter-' + customData[2]).slick("slickPrev");
		} else {
			$('.sym-slides-counter-' + customData[2]).slick("slickNext");
		}
	});

	// Rooms toggle
	$(".tabs-menu a").click(function (event) {
		event.preventDefault();
		$('.sym-slides-counter-0, .sym-slides-counter-1, .sym-slides-counter-2').slick('unslick');
		$('.tabs-menu a').removeClass("active");
		$(this).addClass("active");
		var tab = $(this).attr("href");
		$(".tab-content").not(tab).css("display", "none");
		$(tab).fadeIn();
		var $status0 = $('.pagingInfo-0');
		var $slickElement0 = $('.sym-slides-counter-0');
		$slickElement0.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
			//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
			var i = (currentSlide ? currentSlide : 0) + 1;
			var ofCopy = '<span class="of-copy"> of </span>';
			$status0.html(i + ofCopy + slick.slideCount);
		});
		$slickElement0.slick({
			arrows: true,
			dots: false,
			autoplay: false,
			autoplaySpeed: 4000,
			speed: 500,
			fade: true,
			accessibility: false,
			prevArrow: $('.prev-gallery-0'),
			nextArrow: $('.next-gallery-0')
		});

		var $status1 = $('.pagingInfo-1');
		var $slickElement1 = $('.sym-slides-counter-1');
		$slickElement1.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
			//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
			var i = (currentSlide ? currentSlide : 0) + 1;
			var ofCopy = '<span class="of-copy"> of </span>';
			$status1.html(i + ofCopy + slick.slideCount);
		});
		$slickElement1.slick({
			arrows: true,
			dots: false,
			autoplay: false,
			autoplaySpeed: 4000,
			speed: 500,
			fade: true,
			accessibility: false,
			prevArrow: $('.prev-gallery-1'),
			nextArrow: $('.next-gallery-1')
		});

		var $status2 = $('.pagingInfo-2');
		var $slickElement2 = $('.sym-slides-counter-2');
		$slickElement2.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
			//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
			var i = (currentSlide ? currentSlide : 0) + 1;
			var ofCopy = '<span class="of-copy"> of </span>';
			$status2.html(i + ofCopy + slick.slideCount);
		});
		$slickElement2.slick({
			arrows: true,
			dots: false,
			autoplay: false,
			autoplaySpeed: 4000,
			speed: 500,
			fade: true,
			accessibility: false,
			prevArrow: $('.prev-gallery-2'),
			nextArrow: $('.next-gallery-2')
		});
	});

	// Directions toggle
	/*
 		$(".from-directions a").hover(function(event) {
 				event.preventDefault();
 				$('.from-directions a').removeClass("active");
 				$(this).addClass("active");
 				var tab = $(this).attr("href");
 				$(".directions-content").not(tab).css("display", "none");
 				$(tab).fadeIn();
 		});
 */

	var view_more = document.getElementById('js-more-questions');
	console.log(view_more);
	var questions_container = document.getElementById('questions-asked');
	if (view_more) {
		// validate - only do it only if a view more button exists
		view_more.addEventListener("click", function (event) {
			event.preventDefault();
			if (questions_container.classList.contains('show')) {
				questions_container.classList.remove('show');
				view_more.innerHTML = "+ View information";
			} else {
				questions_container.classList.add('show');
				view_more.innerHTML = "- View information";
			}
		});
	}

	$('.read-more').click(function (e) {
		$(this).next('div.special-full').slideToggle();
		var text = $(this).text();
		$(this).text(text == "Show Less -" ? "Read More +" : "Show Less -");
	});

	$('#content .content li, .landing-page ul.sym-inline-list li').wrapInner('<span></span>');

	$('.login-show').click(function () {
		$('#frmLogin').slideToggle();
	});

	$(".datepicker-specials").datepicker({
		numberOfMonths: 2
	});

	//Event Tracking
	$('.book-now').on('click', function () {
		ga('send', 'event', 'reservations', 'click', 'book now');
	});
	$('.bookNow').on('click', function () {
		ga('send', 'event', 'header widget', 'click', 'book now');
	});
	$('.request-proposal').on('click', function () {
		ga('send', 'event', 'request proposal', 'click', 'request');
	});

	$("#CheckIn-2").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 1,
		dateFormat: 'mm/dd/yy',
		altFormat: "yy-mm-dd",
		altField: "#CheckIn-2-alt",
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut-2").datepicker("setDate", newDate);
			$("#CheckOut-2").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut-2").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 1,
		altFormat: "yy-mm-dd",
		altField: "#CheckOut-2-alt",
		dateFormat: 'mm/dd/yy',
		onSelect: function onSelect(selectedDate) {
			//$( "#CheckIn-2" ).datepicker( "option", "maxDate", selectedDate );
		}
	});
	$("#CheckIn-2f").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 1,
		altFormat: "yy-mm-dd",
		altField: "#CheckIn-2f-alt",
		dateFormat: 'mm/dd/yy',
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut-2f").datepicker("setDate", newDate);
			$("#CheckOut-2f").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut-2f").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 1,
		altFormat: "yy-mm-dd",
		altField: "#CheckOut-2f-alt",
		dateFormat: 'mm/dd/yy',
		onSelect: function onSelect(selectedDate) {
			//$( "#CheckIn-2f" ).datepicker( "option", "maxDate", selectedDate );
		}
	});

	$("#arrival_date_events").datepicker({
		changeMonth: true,
		numberOfMonths: 1,
		dateFormat: 'mm/dd/yy',
		onSelect: function onSelect(selectedDate) {
			var getDate = $(this).datepicker('getDate');
			var newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#departure_date_events").datepicker("setDate", newDate);
			$("#departure_date_events").datepicker("option", "minDate", selectedDate);
			$(this).blur();
			$("#departure_date_events").blur();
		}
	});

	$("#departure_date_events").datepicker({
		changeMonth: true,
		numberOfMonths: 1,
		dateFormat: 'mm/dd/yy',
		onSelect: function onSelect(selectedDate) {}
	});

	$("#arrival_date_flexible").datepicker({
		changeMonth: true,
		numberOfMonths: 1,
		dateFormat: 'mm/dd/yy',
		onSelect: function onSelect(selectedDate) {
			var getDate = $(this).datepicker('getDate');
			var newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#departure_date_flexible").datepicker("setDate", newDate);
			$("#departure_date_flexible").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#departure_date_flexible").datepicker({
		changeMonth: true,
		numberOfMonths: 1,
		dateFormat: 'mm/dd/yy',
		onSelect: function onSelect(selectedDate) {}
	});

	$('#landing-page-2019 .block .btn').click(function (e) {
		e.preventDefault();
		$('html, body').animate({
			scrollTop: $("#culinaryRFP").offset().top
		}, 1000);
	});
	//landing page book by and promo code text
	if ($('body#landing-page').length > 0) {
		if ($('.cyber-monday')) {
			$('<div class="city">72 Hours to Book!</div>').insertAfter($('#header a.logo'));
		} else {
			$('<div class="city">Charleston, Ssssouth Carolina</div>').insertAfter($('#header a.logo'));
		}

		$('#landing-page .countdown').insertAfter($('#header .city'));

		var newT = $('#landing-page #lp-top .offer .container .block h4').text().split('|');
		$('#landing-page #lp-top .offer .container .block h4').html(newT[0]);
		$('#landing-page #lp-top .offer .container .block .bookby').append(newT[1]);
		$('#landing-page #lp-top .offer .container .block .promo').append(newT[2]);

		//Index Countdown
		var day = $('#day').val();
		var month = $('#month').val();
		var year = $('#year').val();
		var hour = $('#hour').val();
		var minute = $('#min').val();
		var second = $('#sec').val();
		setTimeout(function () {
			$('#countdown').countDown({
				targetDate: {
					'day': day,
					'month': month,
					'year': year,
					'hour': hour,
					'min': minute,
					'sec': second
				},
				omitWeeks: true
			});
		}, 800);
	}

	$('.gallery .wrapper').slick({
		arrows: true,
		slidesToShow: 6,
		slidesToScroll: 1,
		accessibility: false
	});

	$("#emailSignupGuestFolio").click(function () {
		$.post(FRONTEND_ROOT + 'ajax/guestfolio.php', $("#email-signup").serialize(), function (data) {

			if (data.error) {
				$("#email-error").html(data.msg);
			} else {
				$("#email-signup").slideUp(function () {
					$("#email-ok").show();
				});
			}
		}, 'json');
	});

	$("#emailSignupGuestFolio-2").click(function () {
		$.post(site_url + 'ajax/guestfolio.php', $("#email-signup-2").serialize(), function (data) {
			if (data.error) {
				$("#email-error-2").html(data.msg);
			} else {
				ga('send', 'event', 'email popin', 'click', 'sign up');
				$('#email-signup-2').slideUp();
				$("#email-ok-2").html('Thank you for joining our list to receive exclusive news and offers.');
				$("#email-ok-2").show();
			}
		}, 'json');
	});
});